import React, { createContext, useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'hide_amounts';

export const AmountVisibilityContext = createContext({
  hideAmounts: true,
  toggleHideAmounts: () => {},
});

export const AmountVisibilityProvider = ({ children }) => {
  const [hideAmounts, setHideAmounts] = useState(() => {
    if (typeof window === 'undefined') return true;
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === null) return true;
      return stored === 'true';
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, hideAmounts ? 'true' : 'false');
    } catch {
      // ignore storage errors
    }
  }, [hideAmounts]);

  const toggleHideAmounts = useCallback(() => {
    setHideAmounts((prev) => !prev);
  }, []);

  return (
    <AmountVisibilityContext.Provider value={{ hideAmounts, toggleHideAmounts }}>
      {children}
    </AmountVisibilityContext.Provider>
  );
};

